import { GetServerSideProps } from "next";
import { useState, useEffect } from "react";
import Image from "../../app/component/commons/image/Image";
import Meta from "../../app/component/commons/meta/Meta";

import { PageProps } from "../../app/helpers/types/getTypes";
import DefaultLayout from "../../app/layouts/DefaultLayout";
import { client } from "../../app/utils/axiosStrapi";
import parse from "html-react-parser";
import { dateFormat } from "../../app/helpers/DateTimeFormat";
import { useRouter } from "next/router";

interface Props {
  params: PageProps;
}

const Index = ({ params }: Props) => {
  const router = useRouter();
  const [mode, setMode] = useState("");

  useEffect(() => {
    // window.analytics.page("viewed");
    if (window.innerWidth < 768) {
      setMode("mobile");
    } else {
      setMode("desktop");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Meta
        title="Terms and Conditions | Storageunitauctionlist.com"
        description={`${params.attributes.short_description}`}
      />
      <DefaultLayout>
        <div className="container mx-auto ">
          <div className="mt-[2.625rem] lg:mt-[5.75rem] mx-4.5 md:mx-16 flex flex-col">
            <div className="uppercase font-medium md:font-bold text-warning-500 text-regular-tight md:text-large-none">
              Terms and Conditions
            </div>
            <div className="text-neutral-900 font-bold text-title3 leading-[2.125rem] lg:!text-title1 mt-[1.375rem] md:mt-3.5 ">
              {params.attributes.title}
            </div>
            <div className="mt-3 md:mt-3.5 text-neutral-700 text-small-normal leading-6 md:!text-lg">
              Last updated:{" "}
              {dateFormat(params.attributes.updatedAt, "LLLL dd, yyyy")}
            </div>
            {params.attributes.cover.data && (
              <div className="w-full mt-3 md:mt-4.5">
                <Image
                  src={`${process.env.NEXT_PUBLIC_STRAPI_BASE_URL}${params.attributes.cover.data.attributes.url}`}
                  alt={params.attributes.cover.data.attributes.alternativeText}
                  className="w-full rounded-3xl"
                />
              </div>
            )}
            <div className="mt-6 ck-content">
              {parse(params.attributes.description)}
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  let params = {};

  try {
    const { data } = await client.get(`/term-and-condition`, {
      ...context,
      params: {
        populate: "*",
      },
    });

    if (data) {
      params = data.data;
    }

    return {
      props: { params },
    };
  } catch (error: any) {
    if (error.response) {
      return {
        redirect: {
          permanent: false,
          destination: `/${error.response.status}`,
        },
      };
    }

    return {
      redirect: {
        permanent: false,
        destination: "/404",
      },
    };
  }
};

export default Index;
